import { render } from "./PartnerApplyView.vue?vue&type=template&id=0c249e33&scoped=true"
import script from "./PartnerApplyView.vue?vue&type=script&lang=js"
export * from "./PartnerApplyView.vue?vue&type=script&lang=js"

import "./PartnerApplyView.vue?vue&type=style&index=0&id=0c249e33&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c249e33"]])

export default __exports__